import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  Image,
  Flex,
  VStack,
} from '@chakra-ui/react';
import Slider from 'react-slick';
import { Parallax } from 'react-parallax';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import customer1 from '../../assets/images/Testimonials/1_1.webp';
import customer2 from '../../assets/images/Testimonials/2.webp';
import customer3 from '../../assets/images/Testimonials/3_1.webp';
import backgroundImage from '../../assets/testimonialBG.webp';

const testimonials = [
  {
    id: 1,
    name: 'Yusuf Amin',
    role: 'Founder, TechTrend Innovations',
    image: customer1,
    text: 'Their team delivered an exceptional website that perfectly captured our brand vision. The professionalism and attention to detail were outstanding, and our online presence has never been stronger.',
  },
  {
    id: 2,
    name: 'Fouad Osman',
    role: 'Chief Marketing Officer, GrowEasy Solutions',
    image: customer2,
    text: 'The mobile app they developed for us was a game-changer. It’s user-friendly, fast, and has significantly boosted our customer engagement. Highly recommend their expertise!',
  },
  {
    id: 3,
    name: 'Fairouz Mhmd',
    role: 'Manager, Visionary Enterprises',
    image: customer3,
    text: 'Their SEO and Google Ads strategies skyrocketed our website traffic and conversions. The team’s data-driven approach and clear communication made the process seamless.',
  },
];

function Testimonials() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: (
      <Box
        className="slick-prev"
        _before={{
          content: '"\\f053"',
          fontFamily: 'FontAwesome',
          color: 'white',
          fontSize: '24px',
        }}
        _hover={{ opacity: 0.8 }}
      />
    ),
    nextArrow: (
      <Box
        className="slick-next"
        _before={{
          content: '"\\f054"',
          fontFamily: 'FontAwesome',
          color: 'white',
          fontSize: '24px',
        }}
        _hover={{ opacity: 0.8 }}
      />
    ),
  };

  return (
    <Parallax
      bgImage={backgroundImage}
      strength={300}
      bgImageStyle={{ objectFit: 'cover' }}
    >
      <Box
        as="section"
        py={20}
        id="testimonials"
        bg="rgba(26, 32, 44, 0.75)" // gray.900 with 75% opacity
        position="relative"
        minH="600px"

      >
        <Container maxW="7xl" position="relative" zIndex={2}>
          <VStack spacing={4} mb={12} textAlign="center">
            <Text
              color="customDarkBlue.500"
              fontWeight="bold"
              textTransform="uppercase"
              fontSize="sm"
            >
              Testimonials
            </Text>
            <Heading as="h2" size="xl" color="white">
              Customers{' '}
              <Box as="span" fontWeight="light" opacity={0.2} >
                Testimonials
              </Box>
            </Heading>
          </VStack>
          <Slider {...settings}>
            {testimonials.map((testimonial) => (
              <Box key={testimonial.id} px={8}>
                <Flex
                  // bg="white"
                  borderRadius="xl"
                  p={8}
                  align="center"
                  justify="center"
                  direction="column"
                  textAlign="center"
                  boxShadow="lg"
                >
                  <Image
                    src={testimonial.image}
                    alt={testimonial.name}
                    borderRadius="full"
                    boxSize="100px"
                    objectFit="cover"
                    mb={4}
                    loading="lazy"
                  />
                  <Text
                    fontSize="lg"
                    color="gray.400"
                    maxW="2xl"
                    fontStyle="italic"
                    mb={4}
                  >
                    "{testimonial.text}"
                  </Text>
                  <VStack spacing={1}>
                    <Text fontWeight="bold" color="gray.300">
                      {testimonial.name}
                    </Text>
                    <Text fontSize="sm" color="gray.500">
                      {testimonial.role}
                    </Text>
                  </VStack>
                </Flex>
              </Box>
            ))}
          </Slider>
        </Container>
      </Box>
    </Parallax>
  );
}

export default Testimonials;